import { useTranslation } from 'react-i18next';
import { SocialTemplate, type SocialTemplateProps } from './SocialTemplate';

type FormatTileProps = Omit<SocialTemplateProps, 'children'>;

/** An empty background at the format's ratio, to build a visual on. */
export default function FormatTile({ gradient = 'from-purple-500/25 to-fuchsia-500/25', ...template }: FormatTileProps) {
  const { t } = useTranslation(['pages']);
  return (
    <SocialTemplate gradient={gradient} {...template}>
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient}`} />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,255,255,0.06),transparent_45%)]" />
      <div className="absolute inset-0 rounded-xl border border-white/10" />
      <div className="absolute inset-0 flex items-center justify-center" data-html2canvas-ignore>
        <div className="rounded-full border border-white/10 bg-black/50 px-3 py-1.5 text-xs text-white/80">
          {t('pages:socialMediaKit.formatPreview')}
        </div>
      </div>
    </SocialTemplate>
  );
}
